// extracted by mini-css-extract-plugin
module.exports = {"head":"intouch_head__3LpeV","br1":"intouch_br1__2Pugc","br2":"intouch_br2__1tBQ7","br3":"intouch_br3__id3nN","fom":"intouch_fom__7Z3md"};